<template lang="pug">
v-layout
  v-snackbar(v-model='showError', color='error')
    div {{ error.service }} {{ error.message }}
  v-btn.primary.ma-0(@click='openModal') PREFERENCES
  liondesk-dialog(
    :dialog-title='dialogTitle',
    :value='isOpenModalSetPreference',
    :disable-ok-button='!noteQualifyTextValid',
    :ok-button-text='dialogOkButton',
    cancel-button-text='Cancel',
    @click:cancel='cancelAddNote()',
    @click:ok='addNote()'
  )
    template(slot='body')
      v-layout.mb-4
        label.v-label.theme--light(:class='{ "edit-text": isSetPreference }') Note:
      label.v-label.theme--light.edit-text(v-if='isSetPreference') {{ getPreference }}
      v-textarea(
        v-if='renderTextArea',
        v-model='noteQualifyTextInput',
        :rules='qualifyTextAreaRules',
        @update:error='noteQualifyInputError'
      )
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import LiondeskDialog from '@/Core/components/LiondeskDialog';

const {
  mapGetters: mapQualifyGetters,
  mapActions: mapQualifyActions,
  mapState: mapQualifyState,
} = createNamespacedHelpers('qualify');
export default {
  name: 'QualifyPreferenceNote',
  components: {
    LiondeskDialog,
  },
  async mounted() {
    await this.loadQualifyCustomer();
  },
  data() {
    return {
      renderTextArea: true,
      noteQualifyTextInput: '',
      qualifyTextAreaRules: [
        value => !!value.trim() || 'Required.',
        value => (value && value.trim().length >= 10) || 'Min 10 characters',
      ],
      noteQualifyTextValid: false,
      isOpenModalSetPreference: false,
    };
  },
  computed: {
    ...mapQualifyState(['error','hasError']),
    ...mapQualifyGetters(['isSetPreference', 'getPreference']),
    dialogTitle() {
      if (this.isSetPreference) {
        return 'EDIT PREFERENCE NOTE FOR QUALIFY';
      }
      return 'SET PREFERENCE NOTE FOR QUALIFY';
    },
    dialogOkButton() {
      if (this.isSetPreference) {
        return 'EDIT NOTE';
      }
      return 'SET NOTE';
    },
    showError: {
        get() {
            return this.hasError;
        },
        set() {
            this.clearError();
        },
    },
  },
  methods: {
    ...mapQualifyActions([
        'loadQualifyCustomer',
        'setPreferencesNote',
        'clearError',
        ]),
    openModal() {
      this.isOpenModalSetPreference = true;
    },
    closeModal() {
      this.isOpenModalSetPreference = false;
    },
    noteQualifyInputError(value) {
      this.noteQualifyTextValid = !value;
    },
    reRenderTextAreas() {
      this.renderTextArea = false;
      this.$nextTick(() => {
        this.renderTextArea = true;
      });
    },
    clearNoteTextArea() {
      this.noteQualifyTextInput = '';
      this.noteQualifyTextValid = false;
      this.reRenderTextAreas();
    },
    cancelAddNote() {
      this.closeModal();
      this.clearNoteTextArea();
    },
    async addNote() {
      this.closeModal();
      const note = this.noteQualifyTextInput.slice().trim();
      if (note !== this.getPreference) {
        await this.setPreferencesNote(note);
        await this.loadQualifyCustomer();
      }
      this.clearNoteTextArea();
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-text {
  font-weight: bold;
}
</style>

